<script>
export default {
    name: "basic-circle",
    props: {
        checked: {
            type: Boolean,
            required: true,
        },
        hideLine: {
            type: Boolean,
            default: false,
        },
        showSecondLine: {
            type: Boolean,
            default: false,
        },
        showDefault: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<template>
    <div class="d-inline">
        <svg v-show="!checked && !showDefault" width="14" height="14" viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z"
                fill="#FFB700"/>
        </svg>
        <svg v-show="checked && !showDefault" width="14" height="14" viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FFB700"/>
            <path d="M4.33301 7L6.33301 9.5L9.66634 4.5" stroke="#FFB700" stroke-linecap="round"
                  stroke-linejoin="round"/>
        </svg>
        <svg v-show="showDefault" width="14" height="14" viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#999999"/>
        </svg>

        <svg v-show="!hideLine" class="line" width="1" height="33" viewBox="0 0 1 33" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <line x1="0.25" y1="-1.09278e-08" x2="0.250001" y2="33" stroke="#999999" stroke-width="0.5"/>
        </svg>
    </div>
</template>
